// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"e7c0892726fd7a2eb55c","655":"4ca6d127d734bc5e683c"}[chunkId] + ".js";
};